import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import Product1 from "../components/Product1";
import Product4 from "../components/Product4";
import point from "../images/point.svg";
import Nodata from "../components/NoData";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import { getCartCookie } from "../services/common";
import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';
import {alert, confirm} from "../components/MegConfirmAlert";
import { Link, useNavigate, useLocation  } from "react-router-dom";

export default function Cart(){
    const { t } = useTranslation();
    const [request] = useAxios();
    const [data, setData] = useState({});
    const [checkItems, setCheckItems] = useState([]);
    const navigate = useNavigate();  

    const lang = localStorage.getItem("language") || "ko";

    const handleSingleCheck = (checked, id) => {
        if (checked) {
          // 단일 선택 시 체크된 아이템을 배열에 추가
          setCheckItems(prev => [...prev, id]);
        } else {
          // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
          setCheckItems(checkItems.filter((el) => el !== id));
        }
      };

      const handleAllCheck = (checked) => {
        if(checked) {
          // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
          const idArray = [];
          data.sellerList.forEach((el) => el.cartList.forEach((el2) => idArray.push(el2.cartSn)));
          setCheckItems(idArray);
        }
        else {
          // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
          setCheckItems([]);
        }
      }

      const fn_moveOder = () => {
        let orderList = [];
        data.sellerList.forEach(function (value, index) {
            value.cartList.forEach(function (value2, index2) {                
                orderList.push(  {
                    goodsSn : value2.goodsSn,
                    goodsOptnSn : value2.goodsOptnSn,
                    cartSn : value2.cartSn,
                    orderQy : value2.goodsQy
                });
            });
        });
        navigate('/Order', {
            state: { from: orderList },
        })
    }

    const onSetTotalAmt= async (amt, key) => {
        var cartCookie = getCartCookie()
        console.log("amt",amt);
        const response = await request.post("/app/cart/modifyCartGoodsQyAPI", {
            cartCookie : cartCookie,
            cartSn : key,
            goodsQy : amt.orderQy,
            userId : cartCookie,
            nationSeCode:lang
        });
        if(response.data.resultCode === 200){
            console.log("set",response.data.result);
            setData(response.data.result);
        }       
    }

    const fn_checkDel = async () => {
        var cartCookie = getCartCookie()
        if(checkItems.length === 0){
            alert(t(`Message.add_cart_bottom_sheet_add_optn_qy_msg`));
            return;
        }

        const result = await confirm(t(`Message.goods_info_remove_cart_confirm`), {okText : t(`Message.common_yes`) , cancelText : t(`Message.common_no`)});
        if(result){
            for(var i =0; i<checkItems.length; i++){
                const response = await request.post("/app/cart/removeCartGoodsAPI", {
                    userId : cartCookie,
                    cartSn : checkItems[i]
                });
                if(response.data.resultCode === 200){
                    setData(response.data.result)  
                }
            } 
        }

    }
    const fetchData = async () => {
        var cartCookie = getCartCookie()
        const response = await request.post("/app/cart/getMyCartAPI", {
            cartCookie : cartCookie,
            nationSeCode:lang
        });
        if(response.data.resultCode === 200){            
            setData(response.data.result);
        }            
    };
    useEffect(() => {
        fetchData();
      }, []);

    return (
        <div className="cartPage">
            <div className="backGround bgBlue"></div>
            <Header type="search" pageTitle={t(`Message.cart_screen_title`)}/>
            {!data.sellerList  ? null :(
             data.sellerList.length === 0 ? (
            <div className="floatCenter">
                <Nodata text={t(`Message.cart_screen_empty_msg`)}/>
                <button type="button" className="btn40 orgB cFFF mt20" onClick={(e)=> window.location.href="/"}>{t(`Message.add_cart_result_continue_shopping`)}</button>
            </div> 
            ) :  (
            <div>
                <div className="cartWr">
                    <ul className="dfsb">
                        <li className="chkWr">
                            <input type="checkbox" id="aa" onChange={(e) => handleAllCheck(e.target.checked)}
                            checked={checkItems.length === data.totalGoodsCnt ? true : false} />
                            <label htmlFor="aa">{t(`Message.all_check_overall_selection`)}</label>
                        </li>
                        <li><button type="button" className="del" onClick={fn_checkDel}>선택삭제</button></li>
                    </ul>
                    {data.sellerList && data.sellerList.map((saller, index) => (     
                    <div className="com" key={index}>
                        <p className="comName">{saller.cmpnm}</p>
                        {saller.cartList && saller.cartList.map((obj, index2) => (  
                        <Product4  key={index2}
                            type="type12" 
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                            prodName={obj.goodsNm}
                            option={obj.firstOptnNm + ' ' +obj.firstOptnValue}
                            obj ={obj}
                            fetchData = {fetchData}
                            checkItems = {checkItems}
                            handleSingleCheck = {handleSingleCheck}                            
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                            num={obj.goodsQy.toLocaleString('ko-KR')}
                            setTotalAmt={onSetTotalAmt}
                        />
                        ))} 
                    

                        <div className="comTotal">
                            <p>￦{saller.sellerGoodsAmount.toLocaleString('ko-KR')} +</p>
                            <p>{t(`Message.seller_amount_label_dlvy_amt`)} ￦{saller.dfltDlvyCtAmount.toLocaleString('ko-KR')} =</p>
                            <p className="fw700">￦{saller.sellerTotAmount.toLocaleString('ko-KR')}</p>
                        </div>
                    </div>
                    ))} 
                    {/*
                    <div className="productList">
                        <p className="tit">함께 주문하면 좋은 상품</p>
                        <Swiper className="recentlyViewedSlide" 
                                slidesPerView={1.15}
                                spaceBetween={12}
                        >
                            <SwiperSlide>
                                <Product1 type="type1" prodName="태국 음료 쉐프초이스 코코넛밀크 400ml, 1개" disprice="1,000원" img="https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn=785"/>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Product1 type="type1" prodName="국내산 냉동 돼지귀" disprice="4,000원" img="https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn=707"/>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    */}
                    <div className="dfColG20">
                        <ul className="priceDetail">
                            <li>
                                <p className="lc">{t(`Message.total_amount_label_tot_goods_amt`)}</p>
                                <p className="rc">￦{data.nrmltTotalAmount.toLocaleString('ko-KR')}</p>
                            </li>
                            <li>
                                <p className="lc">{t(`Message.total_amount_label_tot_sle_amt`)}</p>
                                <p className="rc">-￦{data.saleTotalAmount.toLocaleString('ko-KR')}</p>
                            </li>
                            <li>
                                <p className="lc">{t(`Message.total_amount_label_tot_dlvy_amt`)}</p>
                                <p className="rc">￦{data.sellerList.reduce((accum,item) => accum + item.dfltDlvyCtAmount, 0).toLocaleString('ko-KR')}</p>
                            </li>
                            <li>
                                <p className="lc">{t(`Message.total_amount_label_pay_expect_amt`)}</p>
                                <p className="rc">￦{data.paymentAmount.toLocaleString('ko-KR')}</p>
                            </li>
                        </ul>
                        <div className="expMilegeWr">
                            <img src={point} alt={t(`Message.my_order_confirm_goods_confirm_mlg`)} />
                            <p className="greenTxt">{Number(data.mlgAccml).toLocaleString('ko-KR')}</p>
                            <p>{t(`Message.order_payment_screen_mlg_point`)}</p>
                        </div>
                    </div>
                </div>

                <div className="floatBtnWr">
                <ul className="dfsb">
                    <li>
                        <p className="txt">Total Price</p>
                        <p className="num">￦{data.paymentAmount.toLocaleString('ko-KR')}</p>
                    </li>
                    <li>
                        <button type="submit" className="orderBtn" onClick={(e) => {fn_moveOder();}}>{t(`Message.bottom_navigation_bar_order_btn`)}</button>
                    </li>
                </ul>
                </div>
            </div>
                ))
            }
        </div>
    )
}